import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function BOMItemPage() {
  const [rows, setRows] = useState([]);
  const [boms, setBoms] = useState([]);
  const [materials, setMaterials] = useState([]);

  const [data, setData] = useState({
    bom: "",
    raw_material: "",
    quantity: ""
  });

  useEffect(() => {
    fetchBOMItems();
    fetchBOMs();
    fetchMaterials();
  }, []);

  // Fetch all BOM items
  const fetchBOMItems = () => {
    axios.get(baseUrl + "bom-item/")
      .then(res => setRows(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch BOM items", "error"));
  };

  // Fetch BOM list
  const fetchBOMs = () => {
    axios.get(baseUrl + "bom/")
      .then(res => setBoms(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch BOMs", "error"));
  };

  // Fetch raw materials list (Equipment)
  const fetchMaterials = () => {
    axios.get(baseUrl + "eqp-search/")
      .then(res => setMaterials(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch raw materials", "error"));
  };

  const inputHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // Submit new BOMItem
  const formSubmit = () => {
    if (!data.bom || !data.raw_material || !data.quantity) {
      Swal.fire("Error", "All fields are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("bom", data.bom);
    _formData.append("raw_material", data.raw_material);
    _formData.append("quantity", data.quantity);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "bom-item/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(response => {
      if (response.status === 200 || response.status === 201) {
        Swal.fire({
          title: "BOM Item Created",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });

        setData({ bom: "", raw_material: "", quantity: "" });
        fetchBOMItems();
      }
    })
    .catch(() => Swal.fire("Error", "Something went wrong", "error"));
  };

  // Delete BOMItem
  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm",
      text: "Are you sure you want to delete this?",
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true
    }).then(result => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "bom-items/" + id + "/")
          .then(() => {
            Swal.fire("Deleted", "BOM Item deleted", "success");
            fetchBOMItems();
          });
      }
    });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    {
      field: "bom",
      headerName: "BOM",
      width: 150,
      renderCell: (params) => params.row.bom?.product?.name || "Unknown"
    },
    {
      field: "raw_material",
      headerName: "Raw Material",
      width: 150,
      renderCell: (params) => params.row.raw_material?.product || "Unknown"
    },
    { field: "quantity", headerName: "Quantity", width: 150 },
    {
      field: "edit",
      headerName: "Edit",
      renderCell: (params) => (
        <Link
          to={`/bomitem/edit/${params.row.id}`}
          target="_blank"
          className="btn btn-warning btn-sm"
        >
          Edit
        </Link>
      ),
      width: 120
    },
    {
      field: "delete",
      headerName: "Delete",
      renderCell: (params) => (
        <button
          onClick={() => handleDelete(params.row.id)}
          className="btn btn-danger btn-sm"
        >
          Delete
        </button>
      ),
      width: 120
    }
  ];

  return (
    <div className="container mt-4">

      {/* Form */}
      <div className="card p-4 mb-4">
        <h4>Add BOM Item</h4>

        <select
          className="form-control mt-3"
          name="bom"
          value={data.bom}
          onChange={inputHandler}
        >
          <option value="">Select BOM</option>
          {boms.map(b => (
            <option key={b.id} value={b.id}>
              {b.product?.name} - {b.version}
            </option>
          ))}
        </select>

        <select
          className="form-control mt-3"
          name="raw_material"
          value={data.raw_material}
          onChange={inputHandler}
        >
          <option value="">Select Raw Material</option>
          {materials.map(m => (
            <option key={m.id} value={m.id}>
              {m.product}
            </option>
          ))}
        </select>

        <input
          type="number"
          className="form-control mt-3"
          placeholder="Quantity"
          name="quantity"
          value={data.quantity}
          onChange={inputHandler}
        />

        <button className="btn btn-success mt-3" onClick={formSubmit}>
          Submit
        </button>
      </div>

      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": { color: "primary.main" }
          }}
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight
          components={{ Toolbar: GridToolbar }}
        />
      </div>

    </div>
  );
}

export default BOMItemPage;
